import React from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Compass,
  PartyPopper,
  Shield,
  Award,
  Sunset,
  Cake,
  Wind,
  Gift,
} from "lucide-react";
import { Camera, Heart, ShipWheel, Music, Waves } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";
import SEO from "../Components/SEO";
import { SEO_DATA } from "../config/seoData";

const birthdayFaq = [
  {
    question: "What is a birthday yacht celebration in Mumbai like?",
    answer:
      "A birthday yacht celebration in Mumbai is a private on-water experience where you celebrate with cake, music, sea views and your own group in a more exclusive setting."
  },
  {
    question: "Is a yacht a good venue for an anniversary celebration?",
    answer:
      "Yes. A yacht anniversary celebration feels romantic, scenic and private, making it a memorable option for couples and families."
  },
  {
    question: "What can we do during a birthday or anniversary yacht celebration?",
    answer:
      "Guests often enjoy cake cutting, music, photos, private cruising, family time, sunset views and celebration moments with their group."
  },
  {
    question: "Is this suitable for children and family groups?",
    answer:
      "Yes. Birthday and anniversary yacht celebrations can be suitable for children, adults, couples, families and multi-generation groups."
  },
  {
    question: "Which yacht should I choose for up to 15 guests?",
    answer:
      "For up to 15 guests, a private yacht charter is usually the best option because it offers a more intimate and comfortable experience."
  },
  {
    question: "Which yacht should I choose for more than 15 guests?",
    answer:
      "For more than 15 guests, a yacht party format is usually more suitable because it works better for larger celebration groups."
  },
  {
    question: "How is Indiaboats different for birthday and anniversary celebrations?",
    answer:
      "Indiaboats focuses on premium on-water experiences, helping guests choose the right format and create celebrations that feel smooth, scenic and memorable."
  },
  {
    question: "How do I enquire about a birthday or anniversary yacht celebration in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your date, guest count and celebration type."
  }
];

const Birthdays = () => {
  

 const benefitsList = [
  "Premium yacht celebration experiences in Mumbai",
  "Ideal for birthdays, anniversaries and milestone occasions",
  "Suitable for couples, families and private groups",
  "Beautiful sea views and memorable photo moments",
  "More exclusive than standard celebration venues",
  "Support in choosing the right yacht format",
  "Experience-led planning and smooth coordination",
];

  const outcomes = [
  {
    text: " Cake-cutting ceremony",
    description:
      "Celebrate your special occasion with a memorable cake-cutting ceremony onboard the yacht.",
    icon: <Cake size={20} />,
  },
  {
    text: "Enjoy a Private Cruise",
    description:
      "Sail through Mumbai's beautiful waters while enjoying a peaceful and exclusive yacht experience.",
    icon: <ShipWheel size={20} />,
  },
  {
    text: "Play Your Favorite Music",
    description:
      "Create the perfect celebration atmosphere with your own playlist while cruising on the sea.",
    icon: <Music size={20} />,
  },
  {
    text: "Capture Stunning Photos",
    description:
      "Take unforgettable pictures with the Arabian Sea and Mumbai skyline as your backdrop.",
    icon: <Camera size={20} />,
  },
  {
    text: "Spend Quality Time Together",
    description:
      "Enjoy meaningful moments with your partner, family, or close friends in complete privacy.",
    icon: <Heart size={20} />,
  },
  {
    text: "Plan a Surprise Celebration",
    description:
      "Make birthdays and anniversaries extra special with a thoughtfully planned surprise experience.",
    icon: <Gift size={20} />,
  },
  {
    text: "Enjoy a Beautiful Sunset",
    description:
      "Watch the sun set over the Arabian Sea and create memories you'll cherish forever.",
    icon: <Sunset size={20} />,
  },
  {
    text: "Celebrate at a Unique Venue",
    description:
      "Experience a private yacht celebration that feels far more memorable than a traditional venue.",
    icon: <PartyPopper size={20} />,
  },
];

  return (
    <div>
      <SEO {...SEO_DATA.birthdayAnniversary} />
      <IndiaBoatsTopBar />
      <PremiumNavbar />

       <section className="clsm-mid-root-wrapper">
      
      <div className="clsm-mid-bg-image"></div>
      
     
      <div className="clsm-mid-bg-gradient-overlay"></div>

      <div className="clsm-mid-container">
        
        {}
        <div className="clsm-mid-header">
         <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              Celebrate Life’s Special <br />
              <span className="csrh-title-italic">
                Moments on a Yacht
              </span>
            </h1>
           
          </div>
          <div className="clsm-mid-decorative-line"></div>
        </div>

        {}
        <div className="clsm-mid-editorial-grid">
          {/* Left Column Paragraph */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
              A birthday or anniversary yacht celebration in Mumbai is one of the most memorable ways to celebrate with your partner, family or close friends. Instead of choosing a regular restaurant or banquet venue, a private yacht offers a more scenic, exclusive and personal setting on the water.
              With sea views, open skies, fresh breeze and your own private space, the experience feels more special from the moment you step onboard.
            </p>
          </div>

          {/* Right Column Paragraphs */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
               Whether you are planning a romantic anniversary, a surprise birthday, a family celebration or an intimate milestone event, a yacht adds a premium and unforgettable touch to the occasion.
            </p>
            <p className="clsm-mid-paragraph">
              With Indiaboats, birthday and anniversary yacht celebrations in Mumbai feel smooth, memorable and beautifully experience-led.
            </p>
          </div>
        </div>

        {}
        <div className="clsm-mid-footer">
          <div className="clsm-mid-highlight-badge">
            {/* Highly customized premium dynamic wave-and-breeze sailing wind icon */}
            <svg 
              className="clsm-mid-badge-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M2 10h12a4 4 0 0 1 0 8H12" />
              <path d="M20 10a4 4 0 0 0-4-4H4" />
              <path d="M5 14h14a3 3 0 0 0 0-6H14" />
            </svg>
            <span className="clsm-mid-badge-text">
              Cake, music, and the ocean breeze.
            </span>
          </div>
        </div>

      </div>

      </section>

       <section className="ycf-premium-wrapper">
      <div className="ycf-premium-container">
        
        {}
        <div className="ycf-premium-header">
          <h2 className="rse-section-title">
          Why a Yacht Celebration {" "}
        <span className="rse-serif-italic">
          Feels More Special
        </span>
      </h2>
          <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>

          <div className="custom-image-gallery-container">
  <div className="custom-grid-layout">
    <div className="custom-grid-item">
      <img
        src="/assets/img/birthday8.png"
        alt="Landscape 1"
      />
    </div>
    <div className="custom-grid-item">
     <img
        src="/assets/img/family4.png"
        alt="Landscape 2"
      />
    </div>
    <div className="custom-grid-item">
      <img
        src="/assets/img/birthday6.png"
        alt="Landscape 3"
      />
    </div>
    <div className="custom-grid-item">
     <img
        src="/assets/img/birthday7.png"
        alt="Landscape 4"
      />
    </div>
  </div>
</div>

          
          <div className="ycf-premium-intro-split">
            <p className="ycf-intro-lead">
              A yacht celebration feels different because the setting itself becomes part of the occasion. You are not just celebrating at a venue — you are celebrating on the water in a private, scenic and premium environment.
            </p>
            <p className="ycf-intro-sub">
              The sea creates a beautiful backdrop, the atmosphere feels more intimate and every moment feels more memorable. For couples, it feels romantic and exclusive. For families, it feels private and joyful. For friends, it becomes a celebration people genuinely remember.
            </p>
          </div>
        </div>

        {}
        <div className="ycf-staggered-grid">
          
          {/* Card 1: More Private */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" strokeDasharray="3 3" />
                <circle cx="12" cy="12" r="4" fill="#ffffff" fillOpacity="0.2" />
                <path d="M12 8v8M8 12h8" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Private</h3>
            <p className="ycf-card-paragraph">
              Celebrate with your own group away from crowded venues.
            </p>
          </div>

          {/* Card 2: More Scenic */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M2 17h20M2 20h20" />
                <path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
                <path d="M12 2v2M4.22 4.22l1.42 1.42M19.78 4.22l-1.42 1.42" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Scenic</h3>
            <p className="ycf-card-paragraph">
              Sea views, skyline views and sunset moments make the experience feel more memorable.
            </p>
          </div>

          {/* Card 3: More Personal */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Personal</h3>
            <p className="ycf-card-paragraph">
              The setting feels more intimate and special for birthdays, anniversaries and milestone occasions.
            </p>
          </div>

          {/* Card 4: More Premium */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Premium</h3>
            <p className="ycf-card-paragraph">
              A yacht creates a stronger sense of occasion than a routine celebration venue.
            </p>
          </div>

        </div>

      </div>
    </section>

      

      <section className="rse-root-wrapper">
  <div className="rse-editorial-container">

    <div className="rse-header-block">
      <h2 className="rse-section-title">
        Things to Do During a{" "}
        <span className="rse-serif-italic">
          Birthday or Anniversary Yacht Celebration
        </span>
      </h2>

      <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>

      <p className="rse-section-paragraph">
        A yacht celebration in Mumbai can be relaxed and intimate or more lively
        and social depending on the kind of experience you want.
      </p>
    </div>

    <div className="rse-outcomes-list">
      {outcomes.map((item, index) => (
        <div key={index} className="rse-outcome-list-item">
          <div className="rse-item-main-content">

            <div className="rse-icon-circle">
              {item.icon}
            </div>

            <div className="rse-text-stack">
              <h3 className="rse-item-title">{item.text}</h3>
              <p className="rse-item-desc">{item.description}</p>
            </div>

          </div>
        </div>
      ))}
    </div>

  </div>
</section>

     <section className="wefl-pre-root-wrapper">
  <div className="wefl-pre-editorial-container">
    <div className="wefl-pre-split-layout">
      {/* Left Column: Rich Editorial Copy */}
      <div className="wefl-pre-narrative-column">
        <div className="wefl-pre-header-block">
          <h2 className="wefl-pre-section-title">
            What the Experience{" "}
            <span className="wefl-pre-serif-italic">Feels Like</span>
          </h2>
         
        </div>

        <div className="wefl-pre-text-block wefl-pre-highlight-block">
          <div className="wefl-pre-accent-stripe"></div>
          <p className="wefl-pre-paragraph-lead">
            The experience of celebrating on a yacht is calm, private and
            exciting at the same time. As soon as you step onboard, the setting
            feels different from an ordinary venue. The open water, the breeze
            and the privacy make the occasion feel more elevated and more
            personal.
          </p>
        </div>

        <div className="wefl-pre-text-block">
          <p className="wefl-pre-paragraph">
            For anniversaries, the experience often feels romantic and elegant.
            For birthdays, it can feel lively, joyful and memorable. Whether
            you're planning an intimate celebration for two or a gathering with
            friends and family, the yacht creates an atmosphere that is both
            comfortable and exclusive.
          </p>
        </div>

        <div className="wefl-pre-text-block">
          <p className="wefl-pre-paragraph">
            The sea naturally adds a sense of occasion that makes every
            celebration feel more special without needing elaborate decorations
            or complicated planning. It's a unique setting where every moment
            becomes part of the experience.
          </p>
        </div>

        {/* Features */}
        <div className="wefl-pre-features-list">
          <div className="wefl-pre-feature-item">
            <Heart size={18} className="wefl-pre-feature-icon" />
            <span>Private & Romantic</span>
          </div>

          <div className="wefl-pre-feature-item">
            <PartyPopper size={18} className="wefl-pre-feature-icon" />
            <span>Joyful Celebrations</span>
          </div>

          <div className="wefl-pre-feature-item">
            <Waves size={18} className="wefl-pre-feature-icon" />
            <span>Scenic Sea Experience</span>
          </div>
        </div>
      </div>

      {/* Right Column */}
      <div className="wefl-pre-image-column">
        <div className="wefl-pre-image-wrapper">
          <img
            className="wefl-pre-main-image"
            src="/assets/img/birthday3.png"
            alt="Birthday and anniversary celebration on a luxury yacht in Mumbai"
          />

          <div className="wefl-pre-floating-badge">
            <span className="wefl-pre-badge-title">Private Yacht Experience</span>
            <span className="wefl-pre-badge-subtitle">
              Celebrate on the Sea
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      <section className="csrb-root-wrapper">
      <div className="csrb-editorial-container">
        
        {}
        <div className="csrb-split-layout">
          
          {/* Left Column: Narrative Copy */}
          <div className="csrb-narrative-column">
            <h2 className="csrb-section-title">
              Why Celebrate with  <span className="csrb-serif-italic">Indiaboats</span>
            </h2>
            
            <p className="csrb-lead-paragraph">
              Indiaboats specialises in premium on-water experiences in Mumbai and helps create birthday and anniversary celebrations that feel smooth, scenic and memorable. We understand that these occasions are personal, which is why our focus is not only on the yacht itself, but also on the comfort, coordination and overall feel of the experience.


            </p>

            <p className="csrb-lead-paragraph">
              From helping you choose the right yacht format to guiding you based on guest count and celebration style, Indiaboats makes the process simpler and more enjoyable from the start.
            </p>
          </div>

          {/* Right Column: Premium Interactive List */}
          <div className="csrb-list-column">
            <span className="csrb-list-eyebrow">GOOD FOR</span>
            <ul className="csrb-list">
              {benefitsList.map((item, index) => (
                <li key={index} className="csrb-list-item">
                  <div className="csrb-bullet-wrapper">
                    {/* Minimalist modern checkmark icon inside a subtle geometric container */}
                    <svg 
                      className="csrb-bullet-icon" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="csrb-item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
      </section>

      <section className="wyoi-section">
  <div className="wyoi-container">

    <div className="wyoi-header">
      <h2 className="wyoi-title">
        Which Yacht Option Is <br />
        <span>Right for Your Celebration</span>
      </h2>

      <div className="wyoi-line"></div>

      <p className="wyoi-description">
        The best yacht option usually depends on your group size and the kind of
        celebration you are planning.
      </p>
    </div>

    <div className="wyoi-grid">

      {/* Card 1 */}

      <article className="wyoi-card">

        <div className="wyoi-image-wrapper">
          <img
            src="/assets/img/birthday4.png"
            alt="Private Yacht Charter"
          />

          <div className="wyoi-badge">
            Up to 15 Guests
          </div>
        </div>

        <div className="wyoi-content">

          <h3>Private Yacht Charter</h3>

          <div className="wyoi-divider"></div>

          <p>
            If your birthday or anniversary celebration is for up to 15 guests,
            a Private Yacht Charter is usually the best option. It works well
            for couples, close families and smaller private groups looking for a
            more intimate experience.
          </p>

        </div>

      </article>

      {/* Card 2 */}

      <article className="wyoi-card">

        <div className="wyoi-image-wrapper">
          <img
            src="/assets/img/birthday5.png"
            alt="Yacht Party Format"
          />

          <div className="wyoi-badge">
            More than 15 Guests
          </div>
        </div>

        <div className="wyoi-content">

          <h3>Yacht Party Format</h3>

          <div className="wyoi-divider"></div>

          <p>
            If your celebration is for more than 15 guests, a Yacht Party format
            is usually more suitable. Larger yacht party options give more space
            and work better for bigger family events, social gatherings and
            group celebrations.
          </p>

        </div>

      </article>

    </div>

  </div>
</section>

     {/* <section className="wyor-root-wrapper">
      <div className="wyor-container">
        
        <div className="wyor-header">
           <h2 className="rse-section-title">
                   Which Yacht Option Is <br /> {" "}
        <span className="rse-serif-italic">
          Right for Your Celebration
        </span>
      </h2>
          <div className="wyor-accent-wave">
            <svg viewBox="0 0 100 10" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 5 Q 25 0, 50 5 T 100 5" stroke="#113d48" strokeWidth="2" fill="none" />
            </svg>
          </div>
          <p className="wyor-lead-copy">
            The best yacht option usually depends on your group size and the kind of celebration you are planning.
          </p>
        </div>

        <div className="wyor-comparison-grid">
          
          
          <div className="wyor-card wyor-card-left">
            
            
            <div className="wyor-card-canopy wyor-canopy-left">
              <div className="wyor-badge-capsule">
                <span className="wyor-badge-pulse"></span>
                Up to 15 Guests
              </div>
              
              <div className="wyor-vessel-icon-box">
                <svg 
                  className="wyor-svg-icon" 
                  viewBox="0 0 64 64" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  
                  <path d="M12 42C24 42 26 38 38 38C50 38 52 42 52 42L48 48H16L12 42Z" stroke="#ffffff" strokeWidth="2" strokeLinejoin="round"/>
                  <path d="M22 38L28 16L38 38" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M28 16H34L32 24H26L28 16Z" fill="rgba(255,255,255,0.2)" stroke="#ffffff" strokeWidth="1.5" strokeLinejoin="round"/>
                  <path d="M6 50C18 50 22 48 34 48C46 48 50 50 62 50" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
            
            
            <div className="wyor-card-body">
              <div className="wyor-keel-line"></div>
              <h3 className="wyor-card-title">Private Yacht Charter</h3>
              <div className="wyor-divider-line"></div>
              <p className="wyor-card-paragraph">
                If your birthday or anniversary celebration is for up to 15 guests, a Private Yacht Charter is usually the best option. It works well for couples, close families and smaller private groups looking for a more intimate experience.
              </p>
            </div>
          </div>

         
          <div className="wyor-card wyor-card-right">
            
           
            <div className="wyor-card-canopy wyor-canopy-right">
              <div className="wyor-badge-capsule">
                <span className="wyor-badge-pulse"></span>
                More than 15 Guests
              </div>
              
              <div className="wyor-vessel-icon-box">
                <svg 
                  className="wyor-svg-icon" 
                  viewBox="0 0 64 64" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                
                  <path d="M8 42C20 42 24 36 36 36C48 36 52 42 56 42L52 50H12L8 42Z" stroke="#ffffff" strokeWidth="2" strokeLinejoin="round"/>
                  <path d="M16 36V28H46V36" stroke="#ffffff" strokeWidth="2" strokeLinejoin="round"/>
                  <path d="M24 28V22H40V28" stroke="#ffffff" strokeWidth="1.5" strokeLinejoin="round"/>
                  <circle cx="32" cy="25" r="1.5" fill="#ffffff"/>
                  <circle cx="24" cy="32" r="2" fill="rgba(255,255,255,0.3)" stroke="#ffffff" strokeWidth="1"/>
                  <circle cx="32" cy="32" r="2" fill="rgba(255,255,255,0.3)" stroke="#ffffff" strokeWidth="1"/>
                  <circle cx="40" cy="32" r="2" fill="rgba(255,255,255,0.3)" stroke="#ffffff" strokeWidth="1"/>
                  <path d="M6 52C18 52 22 50 34 50C46 50 50 52 62 52" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
            
           
            <div className="wyor-card-body">
              <div className="wyor-keel-line"></div>
              <h3 className="wyor-card-title">Yacht Party Format</h3>
              <div className="wyor-divider-line"></div>
              <p className="wyor-card-paragraph">
                If your celebration is for more than 15 guests, a Yacht Party format is usually more suitable. Larger yacht party options give more space and work better for bigger family events, social gatherings and group celebrations.
              </p>
            </div>
          </div>

        </div>
      </div>
      </section> */}

      <section className="pfUniqueMainSection" id="birtday_perfect_for">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: "2rem" }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
        "Birthday celebrations for children and adults",
        "Anniversary yacht experiences for couples",
        "Family birthday gatherings",
        "Multi-generation family occasions",
        "Small private group celebrations",
        "Premium milestone celebrations in Mumbai",
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>



       <section className="wtei-section">
      <div className="wtei-container">
        <div className="wtei-grid">
          
          {/* Left Column: Title and Narrative Copy */}
          <div className="wtei-col-left">
             <h2 className="rse-section-title">
        What to Expect {" "}
        <span className="rse-serif-italic">
         with Indiaboats
        </span>
      </h2>
            <p className="wtei-paragraph">
              When you plan a birthday or anniversary yacht celebration with Indiaboats, the experience is designed to feel premium, simple and memorable. We help you understand which type of yacht suits your occasion, what format works best for your group and how to create a celebration that feels special from start to finish.
            </p>
          
          </div>

          { }
          {/* Right Column: Inclusions Style List */}
          <div className="wtei-col-right">
           <ul className="wtei-list">
  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Premium yacht celebration experience
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Guidance based on group size and occasion
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Suitable options for intimate and larger groups
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Scenic sea views and private atmosphere
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      A more special alternative to ordinary venues
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Supportive and experience-led planning
    </span>
  </li>
</ul>
          </div>

        </div>
      </div>
      </section>

        <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Coordination and  <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every yacht celebration. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so your birthday or anniversary celebration feels enjoyable, comfortable and professionally managed.
          </p>
        </div>
      </div>
    </section> 

     <FAQSection
  pageKey="birthday-anniversary-yacht-celebration-mumbai"
  title="Frequently Asked Questions About Birthdays and Anniversary"
  faqData={birthdayFaq}
/>
     
         <div className="pyc-wrapper">
     <div className="pyc-container">
        
        {/* Main Section Header */}
        <div className="pyc-header">
         
          <h2 className="rse-section-title">
        Tailored Birthday {" "}
        <span className="rse-serif-italic">
          Yacht Experiences
        </span>
      </h2>
          
          <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>
        </div>

        {}
        <div className="pyc-unified-box">
          
          {/* Left Side: Up to 15 Guests */}
          <section className="pyc-column">
            {/* Soft backdrop image (4% opacity, shifts on hover) */}
            <div 
              className="pyc-column-bg" 
              style={{ backgroundImage: 'url("assets/img/anniversary1.png")' }}
            />
            
            <div>
              <div className="pyc-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div>
                <span className="pyc-card-badge">Intimate Gatherings</span>
                <h3 className="pyc-card-title">Birthday Yacht Celebration for Up to 15 Guests</h3>
                <p className="pyc-card-copy">
                  If you are planning a smaller birthday or anniversary celebration, a private yacht charter is usually the ideal choice. For up to 15 guests, the experience feels more intimate, more comfortable and more personalised. It is especially well suited for close family gatherings, romantic occasions and smaller premium celebrations.
                </p>
              </div>
            </div>
            
            <a href="private-yacht-charter-mumbai-goa" className="pyc-cta" aria-label="Explore Private Yacht Charters for Up to 15 Guests">
              <span className="pyc-cta-text">Book Now</span>
              <svg className="pyc-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </section>

          {/* Elegant Dividing Line */}
          <div className="pyc-vertical-divider"></div>

          {/* Right Side: More Than 15 Guests */}
          <section className="pyc-column">
            {/* Soft backdrop image (4% opacity, shifts on hover) */}
            <div 
              className="pyc-column-bg" 
              style={{ backgroundImage: 'url("assets/img/birthday2.png")' }}
            />
            
            <div>
              <div className="pyc-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                  <line x1="4" y1="22" x2="4" y2="15" />
                </svg>
              </div>
              <div>
                <span className="pyc-card-badge">Grand Events</span>
                <h3 className="pyc-card-title">Birthday Yacht Celebration for More Than 15 Guests</h3>
                <p className="pyc-card-copy">
                  If you are planning a larger birthday celebration or anniversary event, a yacht party format is usually more suitable. Larger yachts offer a better setup for guest movement, celebration flow and a more social atmosphere for bigger occasions.
                </p>
              </div>
            </div>
            
            <a href="yacht-party-mumbai" className="pyc-cta" aria-label="Explore Private Yacht Parties for More Than 15 Guests">
              <span className="pyc-cta-text">Book Now</span>
              <svg className="pyc-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </section>

        </div>
      </div>
</div>

        
      <Footer />
    </div>
  );
};

export default Birthdays;
